/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type IncentivationDataType = typeof IncentivationDataType[keyof typeof IncentivationDataType];


export const IncentivationDataType = {
  Binary: 'Binary',
  Score: 'Score',
  ManualInput: 'ManualInput',
  None: 'None',
} as const;
